var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        class: _vm.isSidebarMinimized
          ? "dual-sidebar-page-studio__open"
          : "dual-sidebar-page-studio__closed",
        attrs: { id: "dual-sidebar-page-studio" }
      },
      [
        _c(
          "div",
          { staticClass: "menus menu-box-shadow", attrs: { id: "menus" } },
          [
            _c("img", {
              staticClass: "img-minimize",
              attrs: {
                src: require("@/assets/icon-sidebar/minimize" +
                  (!_vm.isSidebarMinimized ? "-two" : "") +
                  ".png"),
                height: "35"
              },
              on: { click: _vm.expandSidebar }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sidebar__nav--container" },
              [
                _c(
                  "div",
                  {
                    staticClass: "label-top",
                    class: _vm.isSidebarMinimized
                      ? "display-show"
                      : "display-hide"
                  },
                  [_vm._v("APPLICATION & UI BUILDER")]
                ),
                _vm._v(" "),
                _c("div", {
                  class: !_vm.isSidebarMinimized
                    ? "separator-show m__t--10"
                    : "separator-hide"
                }),
                _vm._v(" "),
                _c("transition", { attrs: { name: "slide-left" } }, [
                  _c(
                    "ul",
                    { staticClass: "sidebar-nav" },
                    _vm._l(_vm.menusUi, function(menu, index) {
                      return _c(
                        "li",
                        { key: "nested" + index, staticClass: "menus-list" },
                        [
                          _c("j-nested-menu", {
                            attrs: {
                              menu: menu,
                              minimized: _vm.isSidebarMinimized
                            }
                          })
                        ],
                        1
                      )
                    })
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "label-top",
                    class: _vm.isSidebarMinimized
                      ? "display-show"
                      : "display-hide"
                  },
                  [_vm._v("DATABASE & CONNECTIVITY")]
                ),
                _vm._v(" "),
                _c("div", {
                  class: !_vm.isSidebarMinimized
                    ? "separator-show m__t--25"
                    : "separator-hide"
                }),
                _vm._v(" "),
                _c("transition", { attrs: { name: "slide-left" } }, [
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.menu,
                          expression: "menu"
                        }
                      ],
                      staticClass: "sidebar-nav"
                    },
                    _vm._l(_vm.menusDatabase, function(menu, index) {
                      return _c(
                        "li",
                        { key: "nested" + index, staticClass: "menus-list" },
                        [
                          _c("j-nested-menu", {
                            attrs: {
                              menu: menu,
                              minimized: _vm.isSidebarMinimized
                            }
                          })
                        ],
                        1
                      )
                    })
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "label-top",
                    class: _vm.isSidebarMinimized
                      ? "display-show"
                      : "display-hide"
                  },
                  [_vm._v("LOGIC & INTELLIGENCE")]
                ),
                _vm._v(" "),
                _c("div", {
                  class: !_vm.isSidebarMinimized
                    ? "separator-show m__t--25"
                    : "separator-hide"
                }),
                _vm._v(" "),
                _c("transition", { attrs: { name: "slide-left" } }, [
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.menu,
                          expression: "menu"
                        }
                      ],
                      staticClass: "sidebar-nav"
                    },
                    _vm._l(_vm.menusLogic, function(menu, index) {
                      return _c(
                        "li",
                        { key: "nested" + index, staticClass: "menus-list" },
                        [
                          _c("j-nested-menu", {
                            attrs: {
                              menu: menu,
                              minimized: _vm.isSidebarMinimized
                            }
                          })
                        ],
                        1
                      )
                    })
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "label-top",
                    class: _vm.isSidebarMinimized
                      ? "display-show"
                      : "display-hide"
                  },
                  [_vm._v("SETTINGS")]
                ),
                _vm._v(" "),
                _c("div", {
                  class: !_vm.isSidebarMinimized
                    ? "separator-show m__t--25"
                    : "separator-hide"
                }),
                _vm._v(" "),
                _c("transition", { attrs: { name: "slide-left" } }, [
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.menu,
                          expression: "menu"
                        }
                      ],
                      staticClass: "sidebar-nav"
                    },
                    _vm._l(_vm.menusOther, function(menu, index) {
                      return _c(
                        "li",
                        { key: "nested" + index, staticClass: "menus-list" },
                        [
                          _c("j-nested-menu", {
                            attrs: {
                              menu: menu,
                              minimized: _vm.isSidebarMinimized
                            }
                          })
                        ],
                        1
                      )
                    })
                  )
                ])
              ],
              1
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-469a6867", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-469a6867","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/jDualSidebarSetting.vue
// module id = null
// module chunks = 